/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {ContextDto} from '../model/contextDto';
import {DatastoreDto} from '../model/datastoreDto';
import {Partner} from '../model/partner';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorDatastoreService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Créer un nouveau datastore
     * Cette requête permet de créer un nouveau datastore et renvoie le datastore créé. (code 201)&lt;br&gt;Si le datastore a un identifiant, une erreur est renvoyée. (code 400)&lt;br&gt;Noter que chaque datastore est affilié à lui même. (partenaire de lui même)&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Le champ X_DATASTORE_ID correspond au code du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param datastore datastore
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createDatastoreUsingPOST(xDataStoreID: string, datastore: DatastoreDto, observe?: 'body', reportProgress?: boolean): Observable<DatastoreDto>;
    public createDatastoreUsingPOST(xDataStoreID: string, datastore: DatastoreDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreDto>>;
    public createDatastoreUsingPOST(xDataStoreID: string, datastore: DatastoreDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreDto>>;
    public createDatastoreUsingPOST(xDataStoreID: string, datastore: DatastoreDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling createDatastoreUsingPOST.');
        }

        if (datastore === null || datastore === undefined) {
            throw new Error('Required parameter datastore was null or undefined when calling createDatastoreUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DatastoreDto>(`${this.basePath}/api/datastores`,
            datastore,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supprimer un datastore
     * Cette requête permet de supprimer un datastore par son identifiant. (code 204)&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Le champ X_DATASTORE_ID correspond au code du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDatastoreUsingDELETE(xDataStoreID: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteDatastoreUsingDELETE(xDataStoreID: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteDatastoreUsingDELETE(xDataStoreID: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteDatastoreUsingDELETE(xDataStoreID: string, id: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling deleteDatastoreUsingDELETE.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteDatastoreUsingDELETE.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/datastores/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lister toutes les datastores
     * Cette requête permet de lister tous les datastores. (code 200)&lt;br&gt;&lt;b&gt;Un datastore est l&#39;ensemble des données que chaque tenant detient.&lt;/b&gt;
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllDatastoresUsingGET(observe?: 'body', reportProgress?: boolean): Observable<Array<DatastoreDto>>;
    public getAllDatastoresUsingGET(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DatastoreDto>>>;
    public getAllDatastoresUsingGET(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DatastoreDto>>>;
    public getAllDatastoresUsingGET(observe: any = 'body', reportProgress = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<DatastoreDto>>(`${this.basePath}/api/datastores`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer le datastore d&#39;origine
     * Cette requête prend en paramètre le domaine d&#39;un partenanaire et renvoie le datastore d&#39;origine. (code 201)&lt;br&gt;Un exemple de domaine est : &#39;partner.com&#39;
     * @param origin origin
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataFromHostOriginUsingPOST(origin: string, observe?: 'body', reportProgress?: boolean): Observable<ContextDto>;
    public getDataFromHostOriginUsingPOST(origin: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextDto>>;
    public getDataFromHostOriginUsingPOST(origin: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextDto>>;
    public getDataFromHostOriginUsingPOST(origin: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (origin === null || origin === undefined) {
            throw new Error('Required parameter origin was null or undefined when calling getDataFromHostOriginUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ContextDto>(`${this.basePath}/api/datastores/origin`,
            origin,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Récupérer des données d&#39;un datastore à partir d&#39;un tenant et d&#39;un affilié
     * Cette requête prend en paramètre le tenant et l&#39;affilié et renvoie des données à propos de la datastore de ce dernier. (code 200)&lt;br&gt;Le paramètre &lt;b&gt;tenant&lt;/b&gt; est l&#39;identifiant de la datastore.&lt;br&gt;Le paramètre &lt;b&gt;affi&lt;/b&gt; est le code de l&#39;affilié.
     * @param affi affi
     * @param tenant tenant
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDataFromTenantAffiUsingGET(affi: string, tenant: string, observe?: 'body', reportProgress?: boolean): Observable<ContextDto>;
    public getDataFromTenantAffiUsingGET(affi: string, tenant: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContextDto>>;
    public getDataFromTenantAffiUsingGET(affi: string, tenant: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContextDto>>;
    public getDataFromTenantAffiUsingGET(affi: string, tenant: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (affi === null || affi === undefined) {
            throw new Error('Required parameter affi was null or undefined when calling getDataFromTenantAffiUsingGET.');
        }

        if (tenant === null || tenant === undefined) {
            throw new Error('Required parameter tenant was null or undefined when calling getDataFromTenantAffiUsingGET.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContextDto>(`${this.basePath}/api/datastores/${encodeURIComponent(String(tenant))}/${encodeURIComponent(String(affi))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir un datastore
     * Cette requête permet d&#39;obtenir un datastore par son identifiant. (code 200)&lt;br&gt;Si le datastore n&#39;existe pas, une erreur est renvoyée. (code 404)&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;true&lt;/b&gt;, la recherche du datastore se fera par son code, et si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;false&lt;/b&gt;, la recherche se fera par son identifiant.
     * @param id id
     * @param isCode isCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatastoreUsingGET(id: string, isCode?: boolean, observe?: 'body', reportProgress?: boolean): Observable<DatastoreDto>;
    public getDatastoreUsingGET(id: string, isCode?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreDto>>;
    public getDatastoreUsingGET(id: string, isCode?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreDto>>;
    public getDatastoreUsingGET(id: string, isCode?: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDatastoreUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isCode !== undefined && isCode !== null) {
            queryParameters = queryParameters.set('isCode', <any> isCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DatastoreDto>(`${this.basePath}/api/datastores/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Ajouter/Mets à jour un partenaire à un datastore
     * Cette requête permet d&#39;ajouter ou de modifier un partenaire à un datastore. (code 200)&lt;br&gt;Si le partenaire n&#39;existe pas il, la structure sql est créé.&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Le champ X_DATASTORE_ID correspond au code du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param partner partner
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePartnerDatastoreUsingPOST(xDataStoreID: string, partner: Partner, observe?: 'body', reportProgress?: boolean): Observable<DatastoreDto>;
    public savePartnerDatastoreUsingPOST(xDataStoreID: string, partner: Partner, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreDto>>;
    public savePartnerDatastoreUsingPOST(xDataStoreID: string, partner: Partner, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreDto>>;
    public savePartnerDatastoreUsingPOST(xDataStoreID: string, partner: Partner, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling savePartnerDatastoreUsingPOST.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling savePartnerDatastoreUsingPOST.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DatastoreDto>(`${this.basePath}/api/datastores/partner`,
            partner,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Mettre à jour un datastore
     * Cette requête permet de mettre à jour un datastore et renvoie le datastore mis à jour. (code 200)&lt;br&gt;Si le datastore n&#39;est pas valide, une erreur est renvoyée. (code 400)&lt;br&gt;Si le datastore n&#39;a pas pu être mis à jour, une erreur est renvoyée. (code 500)&lt;b&gt; Note : &lt;/b&gt; Le champ X_DATASTORE_ID correspond au code du datastore.
     * @param xDataStoreID X-DataStoreID
     * @param datastore datastore
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateDatastoreUsingPUT(xDataStoreID: string, datastore: DatastoreDto, observe?: 'body', reportProgress?: boolean): Observable<DatastoreDto>;
    public updateDatastoreUsingPUT(xDataStoreID: string, datastore: DatastoreDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatastoreDto>>;
    public updateDatastoreUsingPUT(xDataStoreID: string, datastore: DatastoreDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatastoreDto>>;
    public updateDatastoreUsingPUT(xDataStoreID: string, datastore: DatastoreDto, observe: any = 'body', reportProgress = false): Observable<any> {

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling updateDatastoreUsingPUT.');
        }

        if (datastore === null || datastore === undefined) {
            throw new Error('Required parameter datastore was null or undefined when calling updateDatastoreUsingPUT.');
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<DatastoreDto>(`${this.basePath}/api/datastores`,
            datastore,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtenir les partenaires accessibles d'un datastore
     * Cette requête permet d&#39;obtenir les affiliés accessibles d'un datastore par son identifiant. (code 200)&lt;br&gt;Si le datastore n&#39;existe pas, une erreur est renvoyée. (code 404)&lt;br&gt;&lt;b&gt; Note : &lt;/b&gt; Si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;true&lt;/b&gt;, la recherche du datastore se fera par son code, et si &lt;b&gt;isCode&lt;/b&gt; est à &lt;b&gt;false&lt;/b&gt;, la recherche se fera par son identifiant.
     * @param id id
     * @param isCode isCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDatastoreAccessiblePartnersUsingGET(id: string, isCode?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public getDatastoreAccessiblePartnersUsingGET(id: string, isCode?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public getDatastoreAccessiblePartnersUsingGET(id: string, isCode?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public getDatastoreAccessiblePartnersUsingGET(id: string, isCode?: boolean, observe: any = 'body', reportProgress = false): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getDatastoreAccessiblePartnersUsingGET.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isCode !== undefined && isCode !== null) {
            queryParameters = queryParameters.set('isCode', <any> isCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<String>>(`${this.basePath}/api/datastores/${encodeURIComponent(String(id))}/partners`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
